module.exports = __webpack_public_path__ + "img/a3.2ac949cd.png";